import http from '@/communication/AuthConnection'

/**
* Read the file dropped
*/
const readFile = (pFile, eventId) => {
  const formData = new FormData()
  formData.append('model', pFile)
  formData.append('eventId', eventId)

  return http
    .post('/v1/result/import-by-model', formData, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    })
}

export default readFile



// WEBPACK FOOTER //
// ./src/view/event-result/components/import-model/FileHandle.js